export default __webpack_public_path__ + "static/media/detail_small_4_3.f11008cc.png";